import I18n from 'js/lib/i18n.js.erb'
;(function ($) {
  $(document).ready(function () {
    var $enquiryForm = $('.listing--enquiry-form')
    var $phoneNumber = $('#listings_enquiry_phone_number')

    if ($enquiryForm.length === 0) {
      return
    }

    $phoneNumber.intlTelInput({
      initialCountry: 'AU',
      formatOnInit: true,
      hiddenInput: $phoneNumber.prop('name'),
      autoPlaceholder: 'aggressive',
      customPlaceholder: function () {
        return I18n.t('intl_tel_input.placeholder')
      },
    })
  })
})(jQuery)
